import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/icons/tick-circle.svg'


const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_FilterContent = _resolveComponent("FilterContent")!
  const _component_AdjustmentList = _resolveComponent("AdjustmentList")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_DetailsModal = _resolveComponent("DetailsModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, { pageTitle: "Adjustment List" }),
      _createVNode(_component_FilterContent, {
        btnText: "Adjustment",
        btnLink: "/create-adjustment"
      }),
      _createVNode(_component_AdjustmentList),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ]),
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"delete-popup offcanvas offcanvas-end border-0\" tabindex=\"-1\" id=\"deletePopup\"><div class=\"offcanvas-body p-0\"><div class=\"delete-success\"><img src=\"" + _imports_0 + "\" alt=\"Image\"><span class=\"text-white fw-medium\"> Your product is deleted from the list. </span></div></div></div>", 1)),
    _createVNode(_component_DetailsModal)
  ], 64))
}